import React from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative border-t border-white/5 pt-16 pb-8 mt-10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://customer-assets-rejwkqb3.emergentagent.net/job_cloud-ai-platform-1/artifacts/b16wgngd_Black%20and%20Gold%20Elegant%20Luxury%20Flower%20Jewelry%20Logo.png"
                alt="Pratham Innovations"
                className="h-20 w-auto object-contain shrink-0"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-display font-semibold text-xl tracking-tight gradient-text">
                  Pratham Innovations
                </span>
                <span className="text-[11px] text-amber-200/70 italic tracking-wide -mt-0.5">
                  Where imagination becomes reality
                </span>
              </div>
            </div>
            <p className="text-slate-400 text-sm max-w-sm">
              Delivering AI-driven cloud and digital solutions to help businesses scale faster and operate smarter.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Company</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="/#about" className="hover:text-amber-300">About</a></li>
              <li><a href="/#services" className="hover:text-amber-300">Services</a></li>
              <li><a href="/ai-products" className="hover:text-amber-300">AI Products</a></li>
              <li><a href="/#case-studies" className="hover:text-amber-300">Case Studies</a></li>
              <li><a href="/#contact" className="hover:text-amber-300">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">Get in touch</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li>info@prathaminnovations.com</li>
              <li>UAE · WhatsApp: +971 54 747 3070</li>
              <li>India · Call/WhatsApp: +91 81267 09857</li>
              <li>Amber Gem Tower, Ajman, UAE</li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              {[
                { Icon: Linkedin, label: 'LinkedIn', href: 'https://www.linkedin.com/company/pratham-innovations/', external: true },
                { Icon: Twitter, label: 'Twitter', href: 'https://twitter.com/Pratham2826', external: true },
                { Icon: Mail, label: 'Email', href: 'mailto:info@prathaminnovations.com', external: false }
              ].map(({ Icon, label, href, external }) => (
                <a
                  key={label}
                  href={href}
                  aria-label={label}
                  target={external ? '_blank' : undefined}
                  rel={external ? 'noreferrer' : undefined}
                  className="h-9 w-9 rounded-full border border-white/10 bg-white/[0.03] hover:bg-amber-500/10 hover:border-amber-500/30 flex items-center justify-center transition-colors"
                >
                  <Icon size={14} className="text-slate-300" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} Pratham Innovations. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-slate-300">Privacy</a>
            <a href="#" className="hover:text-slate-300">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
